import { CHANGE_WUID } from '../actionTypes'

export const changeWuid = (wuid?: string) => ({
  type: CHANGE_WUID,
  payload: { wuid },
})
